// Whether a post's server shows emoji reactions: 'all', 'unicode' (no
// custom emoji), 'none' or 'unknown'. Its nodeinfo features decide; for a
// server that lists none, its software.

// show no reactions at all (they arrive and are dropped)
const NONE = new Set(['mastodon', 'hometown', 'gotosocial', 'pixelfed'])
// show custom emoji reactions too
const ALL = new Set([
  'akkoma',
  'misskey',
  'sharkey',
  'firefish',
  'iceshrimp',
  'iceshrimp.net',
  'foundkey',
  'cherrypick',
  'catodon',
  'calckey',
  'fedibird',
  'kmyblue',
])

export const reactionSupport = (instance) => {
  if (!instance) return 'unknown'
  const { software, features = [] } = instance
  // Pleroma's and Akkoma's names for it
  if (
    features.includes('pleroma_custom_emoji_reactions') ||
    features.includes('custom_emoji_reactions')
  ) {
    return 'all'
  }
  if (features.includes('pleroma_emoji_reactions')) return 'unicode'
  if (NONE.has(software)) return 'none'
  if (ALL.has(software)) return 'all'
  return 'unknown'
}
